import _ from 'lodash';
export default {

  isEqualsById(object1, object2) {
    return object1.id === object2.id;
  },

  differenceById(list1, list2) {
    return [..._.differenceWith(list1, list2, this.isEqualsById),
            ..._.differenceWith(list2, list1, this.isEqualsById)];
  },

  sameById(list1, list2) {
    return this.differenceById(list1, list2).length === 0;
  },

  difference(list1, list2) {
    return list1
      .filter(x => !list2.includes(x))
      .concat(list2.filter(x => !list1.includes(x)));
  },

  same(list1, list2) {
    return this.difference(list1, list2).length === 0;
  },

  keepOnlyDuplicatesById(list) {
    return this.keepOnlyDuplicates(list, this.isEqualsById);
  },

  keepOnlyDuplicates(list, comparaisonPredicate) {
    return list.filter((value, index, array) =>
         _.findIndex(array, (element) => comparaisonPredicate(element,value)) === index
      && _.findLastIndex(array, (element) => comparaisonPredicate(element,value)) !== index);
  },

  removeDuplicateById(list) {
    return _.uniqBy(list, 'id');
  }
}